BryanAnthonysWishlist.cachePartiallyFetchedWishlist = function (fetchedWishlist, wishlistId) {
    let storedWishlists = BryanAnthonysWishlist.getCachedWishlists();

    let wishlistKey = '';
    for (let key in storedWishlists.wishlists) {
        if (storedWishlists.wishlists[key].wishlist_id !== wishlistId) {
            continue;
        }
        wishlistKey = key;
        storedWishlists.wishlists[key].products = fetchedWishlist.products;
        storedWishlists.wishlists[key].handle = fetchedWishlist.handle;
        storedWishlists.wishlists[key].title = fetchedWishlist.title;
    }

    localStorage.setItem(BryanAnthonysWishlist.storageKey, JSON.stringify(storedWishlists));

    document.dispatchEvent(new CustomEvent('wishlistChanged', {
        detail: {
            wishlistKey,
            wishlist: storedWishlists.wishlists[wishlistKey]
        }
    }));

    return new BryanAnthonysWishlist.Wishlist(storedWishlists.wishlists[wishlistKey]);
};

BryanAnthonysWishlist.refreshWishlistById = function (wishlistId) {
    const url = `${BryanAnthonysWishlist.baseUrl}/get-wishlist?wishlist_id=${wishlistId}`;

    return new Promise(function (resolve, reject) {
        fetch(url, {headers: new Headers({'Accept': 'application/json'})})
            .then(BryanAnthonys.decodeJsonResponse)
            .then(response => {
                const wishlist = BryanAnthonysWishlist.cachePartiallyFetchedWishlist(response, wishlistId);

                resolve(wishlist);
            })
            .catch(exception => {
                if (exception instanceof ResponseException && exception.response.status === 404) {
                    document.dispatchEvent(new CustomEvent('wishlistNotFoundById', {detail: {wishlistId}}));
                }

                reject(exception);
            });
    });
};

BryanAnthonysWishlist.fetchWishlistByHandle = function (handle) {
    const url = `${BryanAnthonysWishlist.baseUrl}/get-wishlist?handle=${handle}`;

    return new Promise(function (resolve, reject) {
        fetch(url, {headers: new Headers({'Accept': 'application/json'})})
            .then(BryanAnthonys.decodeJsonResponse)
            .then(wishlist => resolve(new BryanAnthonysWishlist.Wishlist(wishlist)))
            .catch(reject);
    });
};

document.addEventListener('wishlistNotFoundById', event => {
    // Delete wishlist from localstorage if for some reason it no longer exists on the server
    let storedWishlists = BryanAnthonysWishlist.getCachedWishlists();

    for (let key in storedWishlists.wishlists) {
        if (storedWishlists.wishlists[key].wishlist_id === event.detail.wishlistId) {
            storedWishlists.wishlists[key] = {};
        }
    }

    localStorage.setItem(BryanAnthonysWishlist.storageKey, JSON.stringify(storedWishlists));
});

class WishlistProducts extends HTMLElement {
    constructor() {
        super();
        this.dataset.wishlist = 'default';
        this.handleFatalError = this.handleFatalError.bind(this);
        this.renderProducts = this.renderProducts.bind(this);

        document.addEventListener('wishlistChanged', event => {
            if (this.dataset.wishlist === event.detail.wishlistKey) {
                const wishlist = event.detail.wishlist;
                this.setProductCount(Array.isArray(wishlist.products) ? wishlist.products.length : 0);
            }
        });
    }

    connectedCallback() {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('w')) {
            this.dataset.wishlist = '';
            BryanAnthonysWishlist.fetchWishlistByHandle(searchParams.get('w'))
                .then(this.renderProducts)
                .catch(this.handleFatalError);

            return;
        }


        if (BryanAnthonysWishlist.customerId) {
            BryanAnthonysWishlist.reconcileCustomerWishlists(this.dataset.wishlist)
                .then(() => this.renderProducts(BryanAnthonysWishlist.getCachedWishlist(this.dataset.wishlist)));

            return;
        }


        let wishlist = BryanAnthonysWishlist.getCachedWishlist(this.dataset.wishlist);
        if (wishlist.getId()) {
            BryanAnthonysWishlist.refreshWishlistById(wishlist.getId())
                .then(this.renderProducts)
                .catch(this.handleFatalError);
        } else {
            this.setEmptyState();
        }
    }

    renderProducts(wishlist) {
        const productHandles = new Set();
        wishlist.getProducts().forEach(product => productHandles.add(product.handle));
        if (!productHandles.size) {
            this.setEmptyState();

            return;
        }

        StorefrontCatalog.fetchFullProductsByHandles(Array.from(productHandles))
            .then(products => {
                const wishlistIsEditable = this.dataset.wishlist && wishlist.getSecret();
                const jsonProducts = this.transformToJsonProducts(products);
                const productCards = this.createProductCards(wishlist, jsonProducts);

                this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                    <ul class="grid product-grid grid--2-col grid--4-col-desktop">
                        ${productCards.map(card => `<li class="grid__item">${card}</li>`).join('')}
                    </ul>
                `));

                if (wishlist.getTitle()) {
                    this.setPageTitle(wishlist.getTitle());
                    this.setProductCount(productCards.length);
                }

                this.addActionButtons(jsonProducts, wishlist, wishlistIsEditable);

                if (productCards.length !== wishlist.getProducts().length && wishlistIsEditable) {
                    this.removeDisabledProducts(wishlist, wishlist, jsonProducts);
                }

                if (productCards.length && wishlistIsEditable) {
                    this.addShareButton();
                }
            })
            .catch(this.handleFatalError);
    }

    transformToJsonProducts(products) {
        const jsonProducts = {};

        products.forEach(product => {
            const jsonProduct = new JsonProduct(product, true);
            jsonProducts[jsonProduct.getHandle()] = jsonProduct;
        });

        return jsonProducts;
    }

    createProductCards(wishlist, jsonProducts) {
        const productCards = [];
        wishlist.getProducts().forEach(product => {
            const jsonProduct = jsonProducts[product.handle];
            if (!jsonProduct) {
                return;
            }

            const variant = jsonProduct.getVariants().find(
                variant => variant.getId() === parseInt(product.variant_id)
            );
            if (!variant) {
                return;
            }

            productCards.push(StorefrontCatalog.renderVerticalProductCard(jsonProduct, variant));
        });

        return productCards;
    }

    removeDisabledProducts(wishlist, jsonProducts) {
        wishlist.getProducts().filter(product => {
            if (!jsonProducts[product.handle]) {
                return true;
            }

            const jsonVariant = jsonProducts[product.handle].getVariants()
                .find(jsonVariant => jsonVariant.getId() === parseInt(product.variant_id));

            return !jsonVariant;
        }).forEach((disabledProduct, index) => {
            setTimeout(
                () => BryanAnthonysWishlist.removeFromWishlist(disabledProduct.variant_id, this.dataset.wishlist),
                100 * (index + 1)
            );
        });
    }

    addActionButtons(jsonProducts, wishlist, isEditable = false) {
        wishlist.getProducts().forEach(product => {
            const productCard = this.querySelector(`product-card[data-card-variant-id="${product.variant_id}"]`);
            if (!productCard) {
                return;
            }

            const jsonProduct = jsonProducts[product.handle];
            const jsonVariant = jsonProduct.getVariants().find(jsonVariant => jsonVariant.getId() === parseInt(product.variant_id));

            const buttons = [];
            if (isEditable) {
                buttons.push([`
                    <wishlist-remove 
                        data-product="${jsonProduct.getId()}" data-variant="${jsonVariant.getId()}" 
                        data-wishlist="${this.dataset.wishlist}" class="wishlist-remove inline-block mt-1"
                    >
                        <button type="button" class="button button--tiny">
                            ${BryanAnthonysWishlist.removeText}
                        </button>
                    </wishlist-remove>
                `]);
            }

            if (
                jsonVariant.isAvailable()
                && !jsonProduct.isOnPreorder()
                && !jsonProduct.isCustomizable()
                && (
                    jsonProduct.getVariants().length === 1
                    || (jsonProduct.getOptions().length === 1 && ['Finish', 'Color'].includes(jsonProduct.getOptions()[0].name))
                )
            ) {
                buttons.push(`
                    <wishlist-to-cart 
                        data-product="${jsonProduct.getId()}" data-variant="${jsonVariant.getId()}" 
                        class="wishlist-to-cart inline-block mt-1"
                    >
                        <button type="button" class="button button--tiny">
                            ${BryanAnthonys.strings.variant.addToCart}
                        </button>
                    </wishlist-to-cart>
                `);
            }

            const target = productCard.querySelector('.card-footer')
                || productCard.querySelector('.card__content')
                || productCard;

            target.insertAdjacentHTML('beforeend', BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(
                `<div class="mt-1 mt-2-desktop">${buttons.join('&nbsp;')}</div>`
            )));
        });
    }

    addShareButton() {
        const placeholder = document.querySelector('[data-wishlist-share]');
        if (!placeholder || !document.querySelector('wishlist-share-feedback')) {
            return;
        }

        placeholder.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <wishlist-share-button data-wishlist="${this.dataset.wishlist}" data-generic-error="${this.dataset.genericError}">
                <button type="button" class="button button--tiny">${BryanAnthonysWishlist.shareButton}</button>
            </wishlist-share-button>
        `));
    }

    setProductCount(count) {
        const pageTitle = this.getPageTitleElement();
        if (pageTitle) {
            pageTitle.querySelectorAll('small').forEach(small => small.remove());
            const small = document.createElement('small');
            small.className = 'wishlist-products-count ml-1';
            small.innerText = ` (${count})`;
            pageTitle.appendChild(small);
        }
    }

    setPageTitle(title) {
        const pageTitle = this.getPageTitleElement();
        if (pageTitle) {
            pageTitle.innerText = title;
        }
    }

    getPageTitleElement() {
        return document.querySelector('[data-wishlist-page-title]');
    }

    setEmptyState() {
        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(`
            <div class="status-banner">
                ${this.dataset.emptyMessage}
            </div>
        `);
    }

    setErrorState(errorMessage = null) {
        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div class="status-banner status-banner--error">
                ${errorMessage || this.dataset.genericError}
            </div>
        `));
    }

    handleFatalError(exception) {
        console.error(exception);

        this.setErrorState();
    }
}

customElements.define('wishlist-products', WishlistProducts);

class WishlistRemove extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', () => {
            const button = this.querySelector('button');
            if (button.classList.contains('loading')) {
                return;
            }

            button.classList.add('loading');

            BryanAnthonysWishlist.removeFromWishlist(this.dataset.variant, this.dataset.wishlist)
                .then(() => {
                    const targetToRemove = this.closest('.grid__item')
                        || this.closest('product-card')
                        || this;

                    targetToRemove.remove();
                })
                .catch(error => {
                    console.error(error);
                    BryanAnthonys.showToast(BryanAnthonys.strings.general.genericAjaxError, 'error');
                })
                .finally(() => button.classList.remove('loading'));
        });
    }
}

customElements.define('wishlist-remove', WishlistRemove);

class WishlistToCart extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', () => {
            const button = this.querySelector('button');
            if (button.classList.contains('loading')) {
                return;
            }

            button.classList.add('loading');
            this.cart = document.querySelector('cart-drawer');
            const formData = new FormData();
            formData.append('id', this.getVariantId());
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', BryanAnthonys.pagePath());
            formData.append('properties[_from_wishlist_page]', 'yes');

            BryanAnthonys.cart.add(formData)
                .then(response => this.cart.renderContents(response, document.activeElement))
                .catch(error => {
                    console.error(error);
                    BryanAnthonys.showToast(BryanAnthonys.strings.cart.error, 'error');
                })
                .finally(() => {
                    button.classList.remove('loading');
                    if (this.cart.classList.contains('is-empty')) {
                        this.cart.classList.remove('is-empty');
                    }
                });
        });
    }

    getVariantId() {
        const productCard = this.closest('product-card');
        if (productCard) {
            const swatches = productCard.querySelector('swatch-buttons');
            if (swatches) {
                return swatches.dataset.variantId;
            }
        }

        return this.dataset.variant;
    }
}

customElements.define('wishlist-to-cart', WishlistToCart);

class WishlistShareButton extends HTMLElement {
    connectedCallback() {
        this.feedback = document.querySelector('wishlist-share-feedback');
        this.feedbackTimeout = null;

        this.addEventListener('click', () => {
            if (BryanAnthonysWishlist.customerId) {
                this.showShareOptions();
            } else {
                this.showLoginPrompt();
            }
        });
    }

    showLoginPrompt() {
        if (this.feedbackTimeout) {
            clearTimeout(this.feedbackTimeout);
        }

        this.feedback.showError(BryanAnthonysWishlist.shareLoginPromptHtml);

        this.feedbackTimeout = setTimeout(() => this.feedback.empty(), 5000);
    }

    showShareOptions() {
        if (this.dataset.shared || this.getButton().classList.contains('loading')) {
            return;
        }

        const titles = this.getTitleOptions();
        if (titles) {
            this.feedback.showTitleSelector(titles, this.dataset.wishlist);
            this.hide();
        } else {
            const url = `${BryanAnthonysWishlist.baseUrl}/get-wishlist-titles`;
            this.getButton().classList.add('loading');
            fetch(url, {headers: new Headers({'Accept': 'application/json'})})
                .then(BryanAnthonys.decodeJsonResponse)
                .then(titles => {
                    localStorage.setItem(BryanAnthonysWishlist.titlesStorageKey, JSON.stringify(titles));

                    this.feedback.showTitleSelector(titles);
                    this.hide();
                })
                .catch(error => {
                    this.feedback.showError(this.dataset.genericError);
                    console.error(error);
                })
                .finally(() => this.getButton().classList.remove('loading'));
        }

    }

    getButton() {
        return this.querySelector('button');
    }

    getTitleOptions() {
        try {
            let titles = JSON.parse(localStorage.getItem(BryanAnthonysWishlist.titlesStorageKey));

            return titles && Array.isArray(titles) && titles.length ? titles : null;
        } catch (e) {
            return null;
        }
    }

    hide() {
        this.classList.add('hidden');
    }
}

customElements.define('wishlist-share-button', WishlistShareButton);

class WishlistShareFeedback extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', event => {
            if (event.target.hasAttribute('data-share-button')) {
                this.cloneWishlist();
            }
        });
    }

    cloneWishlist() {
        const button = this.querySelector('[data-share-button]');
        if (button.classList.contains('loading')) {
            return;
        }

        button.classList.add('loading');

        const wishlist = BryanAnthonysWishlist.getCachedWishlist(
            this.querySelector('[name="wishlist-name"]').value
        );

        if (!wishlist.getId()) {
            this.showError(BryanAnthonys.strings.general.genericAjaxError);
            button.classList.remove('loading');

            return;
        }

        const url = `${BryanAnthonysWishlist.baseUrl}/clone-wishlist`;

        const payload = {
            customer_id: BryanAnthonysWishlist.customerId,
            customer_secret: BryanAnthonysWishlist.customerSecret,
            wishlist_id: wishlist.getId(),
            title: this.querySelector('select').value
        };

        fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }),
            body: JSON.stringify(payload)
        })
            .then(BryanAnthonys.decodeJsonResponse)
            .then(wishlist => this.showClonedWishlist(new BryanAnthonysWishlist.Wishlist(wishlist)))
            .catch(exception => {
                console.error(exception);
                this.showError(BryanAnthonys.strings.general.genericAjaxError);
                button.classList.remove('loading');
            });
    }

    showClonedWishlist(wishlist) {
        const url = `https://${BryanAnthonys.domain}${BryanAnthonys.pagePath()}?w=${wishlist.getHandle()}`;

        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div class="status-banner status-banner--success mb-3">
                <div class="mb-1">${BryanAnthonysWishlist.presentUrlText}</div>
                <copyable-input value="${url}" label="${BryanAnthonysWishlist.presentUrlText}" class="block"></copyable-input>
            </div>
        `));
    }

    showError(error) {
        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div class="status-banner status-banner--error mb-3">${error}</div>
        `));
    }

    showTitleSelector(titles, wishlist) {
        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <div class="wishlist-share-form mb-3">
                <input type="hidden" name="wishlist-name" value="${wishlist}"/>
                <label for="select-wishlist-name" class="mb-2 mb-0-desktop block">
                    ${BryanAnthonysWishlist.selectWishlistNameText}
                </label>
                <div class="select mb-2 mb-0-desktop"">
                    <select name="select-wishlist-name" class="select__select select__select--small" id="select-wishlist-name"></select>
                </div>
                <button type="button" class="button button--small" data-share-button>${BryanAnthonysWishlist.shareButton}</button>
            </div>
        `));

        const selector = this.querySelector('#select-wishlist-name');
        titles.forEach(title => {
            const option = document.createElement('option');
            option.innerText = title;
            selector.appendChild(option);
        });
    }

    empty() {
        this.innerHTML = '';
    }
}

customElements.define('wishlist-share-feedback', WishlistShareFeedback);

class WishlistLoginBanner extends HTMLElement {
    connectedCallback() {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('w')) {
            this.classList.add('hidden');
        }
    }
}

customElements.define('wishlist-login-banner', WishlistLoginBanner);